/**
 * Frecuencias (Hz) de las notas usadas por el set de SFX de speak.
 *
 * Todo el set vive en la **pentatónica mayor de Do** (C-D-E-G-A en varias
 * octavas): cualquier combinación suena consonante, lo que permite construir
 * rachas y arpegios ascendentes sin disonancia. Es el "centro tonal" de la
 * paleta cálida (ver `docs/speak-plan/43-sfx-diseno-sonoro.md`).
 *
 * Referenciar SIEMPRE una nota por su clave (`NOTE.G3`) en vez de un número
 * suelto: un typo (`NOTE.G3` cuando no existe la clave) es un error de
 * compilación, no un sonido mudo en runtime. (Ese fue exactamente el bug del
 * piloto: una nota faltante hacía `frequency.value = undefined` → excepción.)
 */
export const NOTE = {
  C3: 130.81,
  G3: 196.0,
  C4: 261.63,
  D4: 293.66,
  E4: 329.63,
  G4: 392.0,
  A4: 440.0,
  C5: 523.25,
  D5: 587.33,
  E5: 659.25,
  G5: 783.99,
  A5: 880.0,
  C6: 1046.5,
  E6: 1318.51,
  G6: 1567.98,
  A6: 1760.0,
} as const;

export type NoteName = keyof typeof NOTE;
